var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSound = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 14 14",
  ref: ref
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.333
}, /*#__PURE__*/React.createElement("path", {
  d: "M6.417 2.743a.411.411 0 0 0-.702-.29L3.74 4.425a.817.817 0 0 1-.582.24H1.75a.583.583 0 0 0-.583.584v3.5a.583.583 0 0 0 .583.583h1.41a.817.817 0 0 1 .58.241l1.974 1.974a.412.412 0 0 0 .703-.29V2.742ZM9.333 5.25a2.917 2.917 0 0 1 0 3.5M11.296 10.712a5.25 5.25 0 0 0 0-7.424"
}))));
SvgSound.viewBox = '0 0 14 14';
const ForwardRef = /*#__PURE__*/forwardRef(SvgSound);
export default ForwardRef;